export const UPDATE_ENVIRONMENT = 'UPDATE_ENVIRONMENT';
export const ADD_ENVIRONMENT = 'ADD_ENVIRONMENT';
